import { EventEmitter, Injectable } from '@angular/core';
import { default as ppEditor } from '@paypoint-frontend/ckeditor';
import { ckEditorConfig } from './config';
import { DOMParserService } from './parser';

@Injectable()
export class CKEditorService {
  public editorInstance: any;
  public config = ckEditorConfig;

  constructor(private domParserService: DOMParserService) {}

  init(isReadOnly: boolean, eventEmitter: EventEmitter<any>) {
    ppEditor.Editor.create(
      <HTMLElement>document.querySelector('#editor'),
      this.config,
    ).then((editorInstance: any) => {
      this.editorInstance = editorInstance;
      const toolbarElement = this.editorInstance.ui.view.toolbar.element;
      const editableElement = this.editorInstance.ui.view.editable.element;

      if (isReadOnly) {
        this.editorInstance.enableReadOnlyMode('#editor');
        toolbarElement.style.display = 'none';
        editableElement.style.background = '#DDDDDD';
        console.log(
          'this.editorInstance.isReadOnly: ',
          this.editorInstance.isReadOnly,
        );
      } else {
        this.editorInstance.disableReadOnlyMode('#editor');
        toolbarElement.style.display = 'flex';
        console.log(
          'this.editorInstance.isReadOnly: ',
          this.editorInstance.isReadOnly,
        );
      }
      console.log('this.editorInstance: ', this.editorInstance);
      eventEmitter.emit();
    });
  }

  getData(eventEmitter: EventEmitter<any>) {
    eventEmitter.emit(
      this.domParserService.toHTML(this.editorInstance.getData()),
    );
  }

  setData(input: any) {
    this.editorInstance.setData(this.domParserService.getBody(input));
  }
}
